import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileDetailService {

  constructor(private dataService: DataService) { }

  getUser(userId: number) {
    return this.dataService.getRecord('/api/user/getUser/' + userId)
  };

  getBankingDetails(userId: number) {
    return this.dataService.getRecord('/api/debitForm/getAccountDetailsByUserId/' + userId);
  }

  saveProfile(userProfile: any) {
    return this.dataService.post('/api/user/SaveProfile', userProfile);
  };

  resetPin(userProfile: any) {
    return this.dataService.post('/api/user/resetPin', userProfile);
  };

  saveOtpDetails(otpDetails: any) {
    return this.dataService.post('/api/Otp/SaveOtpDetails', otpDetails);
  }
  checkOtp(verfiyOtpDetails: any) {
    return this.dataService.getRecordWithParams('/api/Otp/CheckOtp', verfiyOtpDetails)
  }

  //getNewUssdRequest  (userId:number) {
  //    return this.dataService.makeGETRequestWithoutLoading('/api/gvussd/getNewUssdRequest/' + userId);
  //};

  getNewUssdRequest(userId: number, ussdType: any) {
    return this.dataService.getRecord('/api/gvussd/getNewUssdRequest/?userId=' + userId + '&ussdType=' + ussdType);
  }
  getNewUssdRequests(userId: number, ussdType: any, isCapitec: boolean) {
    return this.dataService.getRecord('/api/gvussd/getNewUssdRequests/?userId=' + userId + '&ussdType=' + ussdType + '&isCapitec=' + isCapitec);
  }
  getBankAccountVerification(bankDetails: any) {
    return this.dataService.post('/api/debitForm/BankAccountVerification', bankDetails);
  };

}
